module.exports = __webpack_public_path__ + "img/10.1c2c0719.jpg";